import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getProduto } from 'config/produto-env';
import { useAuth } from 'context/AuthContext';
import { useActivePhases } from 'hooks/useControlDate';
import { isPreInscricaoAberta, podeAcessarListagemPreInscricao } from 'utils/destino-inicial';

interface PreInscricaoFaseRouteProps {
  /** A listagem também abre na aprovação do gestor; o formulário, não. */
  listagem?: boolean;
  children: ReactNode;
}

/** Fora do período, as páginas da pré-inscrição não abrem nem pela URL: voltam para a home do produto. */
export function PreInscricaoFaseRoute({ listagem = false, children }: PreInscricaoFaseRouteProps) {
  const { controlDates } = useAuth();
  const fases = useActivePhases();

  // Sem as datas ainda não dá para saber se a fase está aberta.
  if (!controlDates?.length) {
    return null;
  }

  const produto = getProduto();
  const liberado = listagem ? podeAcessarListagemPreInscricao(fases, produto) : isPreInscricaoAberta(fases, produto);
  if (!liberado) {
    return <Navigate to={produto === 'PREMIO_ELBB' ? '/home-elbb' : '/home-public'} replace />;
  }

  return <>{children}</>;
}
